function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;

    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    // On the first focusable element and tab backward, focus the last element.
    if (event.target === first && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('keydown', trapFocusHandlers.keydown);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}


// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();

    if (now - lastCall < delay) {
      return;
    }

    lastCall = now;

    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

const backToTopButton = document.querySelector('.js-back-to-top');
const footer = document.querySelector('.footer');

window.addEventListener('scroll', () => {
  const scrollY = window.scrollY || window.pageYOffset;
  const viewportHeight = window.innerHeight;

  if (scrollY > viewportHeight) {
    backToTopButton.classList.add('is-visible');
  } else {
    backToTopButton.classList.remove('is-visible');
  }
});

// Toggle .is-footer when .footer enters viewport
const footerObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      backToTopButton.classList.add('is-footer');
    } else {
      backToTopButton.classList.remove('is-footer');
    }
  });
}, {
  root: null,
  threshold: 0,
});

if (footer) {
  footerObserver.observe(footer);
}

// Scroll to top on click
backToTopButton.addEventListener('click', () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
});

//scroll to reviews
let reviewsAnchor = document.querySelector(".js-reviews-anchor");

if (reviewsAnchor) {
  const reviewsSection = document.querySelector(".pdp-reviews");

  if (reviewsSection) {
    reviewsAnchor.addEventListener("click", (event) => {
      if (event.target.closest(".yotpo-star-rating-reviews-summary-link")) return;

      reviewsSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    });
  }
}

//mobile search toggle
const searchToggles = document.querySelectorAll(".js-search-toggle");
if (searchToggles.length) {
  searchToggles.forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      e.preventDefault();

      if (
        document
          .querySelector(".header")
          .classList.contains("header--search-active")
      ) {
        document
          .querySelector(".header")
          .classList.remove("header--search-active");
        document.querySelector("body").classList.remove("shadow--body");
      } else {
        document
          .querySelector(".header")
          .classList.add("header--search-active");
        document.querySelector("body").classList.add("shadow--body");
        document.querySelector("#header-search-input-mobile").focus();
      }
    });
  });
}

//calculate header height
function setHeaderHeight() {
  const headerHeight = document.querySelector(".section-header")
    ? document.querySelector(".section-header").offsetHeight
    : 0;
  document.documentElement.style.setProperty(
    "--header-height",
    `${headerHeight}px`
  );
}
setHeaderHeight();
window.addEventListener("resize", () => {
  setHeaderHeight();
});

//Add to bag functionality
class AddProduct extends HTMLElement {
  constructor() {
    super();

    this.quickAdd = document.querySelector(".js-quick-add");
    this.addEventListener("click", () => {
      if (
        window.innerWidth <= 420 &&
        this.quickAdd &&
        this.closest("product-card") &&
        !this.closest(".js-quick-add") &&
        !this.closest(".mini-cart__recommendations")
      ) {
        this.showQuickAdd();
      } else {
        this.addProduct();
      }
    });

    //Key up and body click events
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.hideQuickAdd()
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
    if (this.quickAdd) {
      this.quickAdd.addEventListener("close", () => {
        this.hideQuickAdd();
      });
    }
  }

  async addProduct() {

    this.classList.add("loading");
    this.setAttribute("disabled", true);
    const variantId = this.getAttribute("data-id");
    const complimentaryProduct = this.getAttribute("data-complimentary");
    const complimentaryProductMessage = this.getAttribute("data-complimentary-message");
    const giftsData = this.getAttribute('data-gifts');

    let properties = {};

    if (complimentaryProduct != null) {
      properties = {
        [complimentaryProduct]: complimentaryProductMessage,
        "_free_products": giftsData
      }
    }

    function getCookie(name) {
      // Construct the name to look for in the cookie string
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();

      return null; // If the cookie doesn't exist, return null
    }

    // Usage example as part of a conditional
    if (getCookie('subscriber_discount') === 'true') {
      properties = {
        ...properties,  // Spread existing properties
        '_subscriber_discount': 'true'
      };
    }

    const itemsToAdd = [];

    itemsToAdd.push({
      id: variantId,
      quantity: 1,
      properties: properties,
    });

    if (giftsData) {
      const giftItems = this.addFreeProducts(giftsData);

      if (giftItems.length) {
        giftItems.forEach((gift) => {
          itemsToAdd.push({
            id: gift,
            quantity: 1,
            properties: {
              "_free_product": true,
            }
          });
        });
      }
    }

    fetch(`${routes.cart_add_url}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: itemsToAdd,
      }),
    }).then(() => {
      this.classList.remove("loading");
      this.removeAttribute("disabled");
      publish(PUB_SUB_EVENTS.cartAdd);
    });
  }

  addFreeProducts(data) {
    if (!data) return;

    const gifts = data.split(',').map((gift) => {
      return gift;
    });

    return gifts;
  }

  showQuickAdd() {
    document.body.classList.add("shadow");
    document.body.style.top = `-${window.scrollY}px`;
    document.body.style.position = "fixed";
    this.quickAdd.innerHTML = this.closest("product-card").outerHTML;
    this.quickAdd.classList.add("active");

    document.body.addEventListener("click", this.onBodyClick, {
      passive: true,
    });

    const closeButton = this.quickAdd.querySelector(".js-close-quick-add");
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        this.hideQuickAdd();
      });
    }
  }

  hideQuickAdd() {
    document.body.classList.remove("shadow");
    const scrollY = document.body.style.top;
    document.body.style.top = "";
    document.body.style.position = "";
    window.scrollTo(0, parseInt(scrollY || 0) * -1);
    this.quickAdd.classList.remove("active");

    document.body.removeEventListener("click", this.onBodyClick, {
      passive: true,
    });
  }

  //Body click event to close quick add
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this && !target.closest(".js-quick-add")) {
      this.hideQuickAdd();
    }
  }
}

customElements.define("add-product", AddProduct);

//Expanding content card
const expandButtons = document.querySelectorAll(".js-card-expand");
if (expandButtons.length) {
  expandButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      button.closest(".card").classList.toggle("expanded");
    });
  });
}

//Quantity input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.minusButton = this.querySelector('button[name="minus"]');
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));

      if (this.input.value == this.input.min) {
        this.minusButton.setAttribute("disabled", true);
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }

    if (this.input.value == this.input.min) {
      this.minusButton.setAttribute("disabled", true);
    } else {
      this.minusButton.removeAttribute("disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

// Subscriber Discount
if (document.cookie.includes('subscriber_discount=true')) {
  // Optionally, you can do something for subscribers here
  const discountInput = document.getElementById('subscriberDiscount');
  if (discountInput) {
    discountInput.value = 'true'; // Set the value to an empty string
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href^="#"]');

  links.forEach(link => {
    link.addEventListener('click', function(e) {
      const targetId = this.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        e.preventDefault();
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
});